import { Component, inject } from "@angular/core";
import { LogoutStore } from "@app-logout/data-access/logout.store";
import { AuthStore } from "@app-auth/data-access/auth.store";
import { SlideUpComponent } from "@shared/components/slide-up/slide-up.component";
import { ButtonComponent } from "@shared/components/button/button.component";
@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: true,
    imports: [SlideUpComponent, ButtonComponent],
}) export class LogoutComponent {
    public readonly logoutStore = inject(LogoutStore);
    public readonly authStore = inject(AuthStore);

    public logout(): void {
        this.logoutStore.toggleLogoutDialog(false);
        // O ChatStore não é injetado aqui de propósito: este componente é renderizado
        // eagerly pelo AppComponent, e injetá-lo colocava o @microsoft/signalr no bundle
        // inicial de todas as rotas — inclusive as de login, onde não há sessão. O
        // teardown do chat acontece pelo próprio ChatStore, que já observa AuthData
        // ficar nula (efeito no withHooks/onInit) e se desmonta sozinho.
        this.authStore.logout();
    }
}